import React from "react";

type Props = {
  notices: (JSX.Element | string)[];
};

export const InputNoticeList: React.FC<Props> = ({ notices }) => {
  return (
    <div className="content is-size-7 mb-2">
      <ul className="mt-0">
        {notices.map((element) => {
          return (
            <li key={typeof element === "string" ? element : element.key}>
              {element}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
